export default "/images/waypoint-icon.svg?7c971c2e53822e6ee5c2840f2804071b";